import axios from 'axios'
import Vue from 'vue'
import { buildVisiblePrice } from './buildVisiblePrice.js'
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { Loader } from '@googlemaps/js-api-loader'
import tippy, { followCursor } from 'tippy.js';
Vue.component('map-popup', {
    //template: require('../../Views/Shared/_MapPopup.html'),
    template: `#info-template`,
    props: ['data', 'isLoading'],
    updated: function () {
        tippy('[data-tippy-content]', {
            followCursor: 'horizontal',
            plugins: [followCursor],
        });
    },
});
Vue.component('file-settings-icon', {
    template: '#file-settings-icons-template',
    props: ['iconGroup', 'iconInGroup', 'duplexMode']
});
Vue.component('printer-details-panel', {
    template: `#printer-details-panel-template`,
    props: ['data', 'isLoading']
});
class MapNew {
    printpoint = null;
    mapApp = null;
    constructor(printpoint) {
        this.printpoint = printpoint;
        var mapWrapperEl = document.getElementById('map-wrap');
        axios.get('places/map').then(
            response => {
                mapWrapperEl.innerHTML = response.data;
                this.initLoader();
            }).catch(error => {
                console.log('err', error);
            });



    }
    changePrintPoint(printpoint) {
        this.mapApp.printpoint = printpoint;
        this.printpoint = printpoint;
    }
    initLoader() {
        let infoWindow;
        let pinIcon;
        let userMarker;
        let userLocation;
        let markerGroup = null;
        const regexLat = /^(-?[1-8]?\d(?:\.\d{1,18})?|90(?:\.0{1,18})?)$/;
        const regexLon = /^(-?(?:1[0-7]|[1-9])?\d(?:\.\d{1,18})?|180(?:\.0{1,18})?)$/;

        function check_lat_lon(lat, lon) {
            let validLat = regexLat.test(lat);
            let validLon = regexLon.test(lon);
            return validLat && validLon;
        }
        const scrollHeaders = (function () {
            let groups;

            const init = function (list) {
                if (list.querySelector('.stickylist-fix-header') !== null) list.querySelector('.stickylist-fix-header').remove();

                if (list.querySelector('.stickylist-wrapper') === null) {
                    let wrapper = document.createElement('div');
                    wrapper.classList.add('stickylist-wrapper');
                    Array.from(list.children).forEach(item => wrapper.appendChild(item));
                    list.appendChild(wrapper);
                }

                let header = document.createElement('div');
                header.classList.add('stickylist-fix-header');
                list.prepend(header);

                groups = list.querySelectorAll('.pic-placeslist-partner');
                groups.forEach(item => {
                    item.dataset.originalPosition = item.offsetTop;
                    item.dataset.originalHeight = item.offsetHeight;
                })

                let scrollbarWidth = document.querySelector('.stickylist-wrapper').offsetWidth - document.querySelector('.stickylist-wrapper').clientWidth;
                list.querySelector('.stickylist-fix-header').style.width = 'calc(100% - ' + scrollbarWidth + 'px)';

                onScrolling();

                list.querySelector('.stickylist-wrapper').removeEventListener('scroll', onScrolling);
                list.querySelector('.stickylist-wrapper').addEventListener('scroll', onScrolling);
            };

            const onScrolling = function () {
                let currentTop = document.querySelector('.stickylist-wrapper').scrollTop;
                let topGroup;

                groups.forEach(item => {
                    let thisGroupOPos = item.dataset.originalPosition;

                    if (thisGroupOPos - currentTop <= 0) {
                        topGroup = item;
                    }
                });

                if (topGroup) {
                    document.querySelector('.stickylist-fix-header').innerHTML = topGroup.querySelector('.pic-placeslist-partner-header').innerHTML;
                }
            };

            return {
                init: init
            };
        }());
        const loader = new Loader({
            apiKey: document.getElementById('googleApiKey').value,
            version: 'weekly',
            language: window.currentLanguageCode
        });
        loader.load().then(() => {
            let filterProperties = { 'hasColor': false, 'hasA3': false };
            let printpointTest = this.printpoint;
            this.mapApp = new Vue({
                el: '#map-wrap',
                data: {
                    allPlaces: [],
                    currentLanguageCode: window.currentLanguageCode,
                    currentPopup: null,
                    filters: {},
                    isPlacesListVisible: false,
                    isPrinterDetailsPanelVisible: false,
                    isSearchBarSelected: false,
                    isSelectedPrinterDataLoading: false,
                    markers: [],
                    //mapOpened: true,
                    model: model.googleApiKey,
                    media: appMain.media,
                    searchDebounce: null,
                    searchString: '',
                    selectedPrinterId: null,
                    selectedPrinterData: null,
                    printpoint: printpointTest,
                },
                computed: {
                    filteredPlaces: function () {

                        // Järgnev rida teeb algsest objektist täieliku klooni.
                        // Kui seda ei tee, siis hakkab filtreerimine mõlutama algset punktide nimekirja.
                        let tmpAllPlaces = JSON.parse(JSON.stringify(this.allPlaces));
                        let result;
                        if (this.printpoint && this.printpoint != 'vjsp') {
                            result = tmpAllPlaces.filter(place => place.id == this.printpoint);
                            if (result.length != 0) {
                                return result;
                            }
                        }

                        // Filtreerib välja partnerid, mille partneri nimes, printerite nimes või aadressis leidub otsitav tekst.
                        result = tmpAllPlaces.filter(place => {
                            place.printers = place.printers.filter(printer => {
                                // otsing sisaldab partneri nime
                                var cond1 = place.name.toLowerCase().includes(this.searchString.toLowerCase());
                                // otsing sisaldab prindipunkti nime või prindipunkti aadressi
                                var cond2 = (printer.name.toLowerCase().includes(this.searchString.toLowerCase()) ||
                                    printer.deviceInfo.streetAddress.toLowerCase().includes(this.searchString.toLowerCase()) ||
                                    printer.deviceInfo.locationDescription[currentLanguageCode].toLowerCase().includes(this.searchString.toLowerCase()) ||
                                    printer.deviceInfo.locationDescription.en.toLowerCase().includes(this.searchString.toLowerCase())
                                );

                                // prindipunktil on vajalik võimekus (A3 / Värviprint)
                                var cond3 = true;
                                for (const [key] of Object.entries(this.filters)) {
                                    if (!printer.capabilities[key] && this.filters[key]) {
                                        cond3 = false;
                                    }
                                }

                                // Partneri või prindipunkti nimes sisaldus string JA prindipunktil on võimekus vastavalt filtritele printida
                                return (cond1 || cond2) && cond3;
                            });
                            return place.printers.length;
                        });
                        return result;

                    }
                },
                methods: {
                    geoLocateMe: function () {
                        if (navigator.geolocation) {
                            navigator.geolocation.getCurrentPosition(
                                (position) => {
                                    const pos = {
                                        lat: position.coords.latitude,
                                        lng: position.coords.longitude,
                                    };
                                    map.panTo(pos);
                                    map.setZoom(14);
                                    const userIcon = {
                                        className: 'pic-marker pic-marker-magenta',
                                        path: 'M10 0C4.476 0 0 4.478 0 10c0 9.548 10 22 10 22s10-12.452 10-22c0-5.522-4.477-10-10-10zm0 15.52c-2.983 0-5.4-2.418-5.4-5.4s2.417-5.4 5.4-5.4c2.982 0 5.4 2.418 5.4 5.4s-2.418 5.4-5.4 5.4z',
                                        fillColor: '#01AEF0',
                                        fillOpacity: 1,
                                        strokeWeight: 0,
                                        scale: 1,
                                        anchor: new google.maps.Point(10, 30)
                                    };
                                    if (!userMarker || !userLocation) {
                                        userMarker = new google.maps.Marker({
                                            position: pos,
                                            map,
                                            title: 'Location',
                                            icon: userIcon
                                        });
                                        userLocation = new google.maps.Circle({
                                            strokeColor: '#01AEF0',
                                            strokeOpacity: 0.8,
                                            strokeWeight: 2,
                                            fillColor: '#01AEF0',
                                            fillOpacity: 0.35,
                                            map,
                                            center: map.getCenter(),
                                            radius: 100,
                                        });
                                    }

                                }
                            );
                        } else {
                            // Browser doesn't support Geolocation

                            //alert();
                        }

                    },
                    getPrice: function (prices, code) {
                        var price = '-';
                        for (let i = 0; i < prices.length; i++) {
                            if (prices[i].code === code) {
                                price = prices[i].price <= 0 ? '-' : buildVisiblePrice(prices[i].price, model.currencyInfo, 2, 4);
                            }
                        }

                        return price;
                    },
                    initFilters: function () {
                        for (const [key] of Object.entries(filterProperties)) {
                            var allHave = true;
                            this.allPlaces.forEach(place => {
                                if (!place.capabilities[key]) {
                                    allHave = false;
                                }
                            });
                            if (allHave) {
                                delete filterProperties[key];
                            }
                        }
                        this.filters = filterProperties;
                    },
                    localizeOpenTimesOrLocation: function (input) {
                        let result = '';
                        if (typeof input[this.currentLanguageCode] !== 'undefined' && input[this.currentLanguageCode] !== '') {
                            result = input[this.currentLanguageCode]
                        }
                        else {
                            result = typeof input.en !== 'undefined' ? input.en : ''
                        }

                        return result
                    },
                    onSearchBarInputBlur: function () {
                        if (this.searchString.length === 0) this.isSearchBarSelected = false;
                    },
                    printerDetailsToggleButtonClick: function () {
                        this.isPrinterDetailsPanelVisible = false;
                    },
                    searchBarCleanButtonClick: function () {
                        document.querySelector('input.searchbar-input').value = '';
                        this.searchString = '';
                    },
                    searchBarIconClick: function () {
                        document.querySelector('input.searchbar-input').focus();
                    },
                    searchBarToggleButtonClick: function () {
                        this.isPlacesListVisible = !this.isPlacesListVisible;
                        this.isPrinterDetailsPanelVisible = false;
                    },
                    updatePins: function () {
                        pinIcon = {
                            className: 'pic-marker pic-marker-magenta',
                            path: 'M10 0C4.476 0 0 4.478 0 10c0 9.548 10 22 10 22s10-12.452 10-22c0-5.522-4.477-10-10-10zm0 15.52c-2.983 0-5.4-2.418-5.4-5.4s2.417-5.4 5.4-5.4c2.982 0 5.4 2.418 5.4 5.4s-2.418 5.4-5.4 5.4z',
                            fillColor: '#ED018C',
                            fillOpacity: 1,
                            strokeWeight: 0,
                            scale: 1,
                            anchor: new google.maps.Point(10, 30)
                        };

                        const icon = {
                            path: 'M10 0C4.476 0 0 4.478 0 10c0 9.548 10 22 10 22s10-12.452 10-22c0-5.522-4.477-10-10-10z',
                            fillColor: '#ED018C',
                            fillOpacity: 1,
                            strokeWeight: 0,
                            scale: 1,
                            scaledSize: new google.maps.Size(100, 100),
                            labelOrigin: { x: 10, y: 10 },
                            anchor: new google.maps.Point(0, 40),
                        };

                        this.markers.forEach(marker => {
                            marker.setMap(null);
                        });
                        this.markers = [];
                        var bounds = new google.maps.LatLngBounds();
                        for (var i = 0; i < this.filteredPlaces.length; ++i) {
                            for (var p = 0; p < this.filteredPlaces[i].printers.length; p++) {
                                var loc = this.filteredPlaces[i].printers[p].deviceInfo.coordinates;
                                if (loc) {
                                    var split = loc.split(',');
                                    if (split[0] !== '' && split[1] !== '' && check_lat_lon(split[0], split[1])) {

                                        var marker = {};

                                        marker = new google.maps.Marker({
                                            position: {
                                                lng: parseFloat(split[0]),
                                                lat: parseFloat(split[1])
                                            },
                                            map,
                                            title: this.filteredPlaces[i].printers[p].name,
                                            icon: pinIcon
                                        });
                                        marker.id = this.filteredPlaces[i].printers[p].id;
                                        bounds.extend(marker.position);
                                        this.markers.push(marker);
                                    }
                                }
                            }
                        }
                        this.markers.forEach(marker => {
                            marker.addListener('click', function () {
                                this.clickOnMarker(marker);
                            }.bind(this));
                        });
                        if (this.markers.length > 0) {
                            map.fitBounds(bounds);
                        }

                        let renderer = {
                            render({ count, position }) {
                                return new google.maps.Marker({
                                    label: { text: String(count), color: 'white', fontSize: '14px' },
                                    position,
                                    icon,
                                    // adjust zIndex to be above other markers
                                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                                });
                            },
                        }
                        var _markers = this.markers;
                        if (markerGroup === null) {
                            markerGroup = new MarkerClusterer({ map, _markers, renderer });
                        }

                        markerGroup.clearMarkers();
                        markerGroup.addMarkers(this.markers);
                    },
                    searchWithDelay: function (event) {
                        clearTimeout(this.searchDebounce);
                        this.searchDebounce = setTimeout(() => {
                            this.searchString = event.target.value;
                        }, 500);
                    },
                    selectPrinter: function (event) {
                        var curMarker = this.markers.find(x => x.id === event.id);
                        this.clickOnMarker(curMarker);
                        if (this.media.isMediaSm === true || this.media.isMediaXs === true) {
                            this.isPlacesListVisible = false;
                        }
                    },
                    fitMapToDisplay: function (isPlacesListVisible) {
                        if (!(this.media.isMediaSm === true || this.media.isMediaXs === true)) {
                            if (!isPlacesListVisible) {
                                if (window.currentLanguageCode === 'ar') {
                                    map.panBy(-200, 0)
                                } else {
                                    map.panBy(200, 0)
                                }
                            }
                            else {
                                if (window.currentLanguageCode === 'ar') {
                                    map.panBy(200, 0)
                                } else {
                                    map.panBy(-200, 0)
                                }
                            }
                        }
                    },
                    clickOnMarker: function (marker) {
                        this.selectedPrinterId = marker.id;
                        this.currentPopup = marker;

                        if (this.media.isMediaXs || this.media.isMediaSm) {
                            this.isPrinterDetailsPanelVisible = true;

                            map.panTo(marker.getPosition());
                            map.setZoom(15);
                            var visibleMapHeight = ((document.getElementById('map').clientHeight + 60) * 0.4 - 52) / 2;
                            var mapCenter = document.getElementById('map').clientHeight / 2;
                            map.panBy(0, mapCenter - visibleMapHeight - 24);
                        }
                        else {
                            map.panTo(marker.getPosition());
                            map.setZoom(17);
                            infoWindow.setContent(this.$refs.mappopup.$el);
                            infoWindow.open(map, marker);

                            var markerPopupHeight = document.getElementById('infoObj').clientHeight || 329;
                            map.panBy(0, -(markerPopupHeight / 2))
                        }
                    }
                },
                mounted: function () {
                    //console.log(model.googleApiKey, 'googleapikey');
                    console.log('appPlaces mounted');
                    if (document.body.classList.contains('page-prices') || document.body.classList.contains('page-jobs')) {
                    } else {
                        document.body.classList.add('page-places', 'footer-fixed');
                    }


                    axios.get('/api/v1.0/places')
                        .then((response) => {
                            this.allPlaces = response.data.value;
                            this.initFilters();
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                },
                watch: {
                    filteredPlaces: function (val) {
                        Vue.nextTick()
                            .then(function () {
                                scrollHeaders.init(document.getElementById('placesList'));
                            });
                        this.updatePins();
                    },
                    media: {
                        deep: true,
                        handler: function (val) {
                            if (this.currentPopup !== null) {
                                map.panTo(this.currentPopup.getPosition());
                                if (val.isMediaSm === true || val.isMediaXs === true) {
                                    infoWindow.close();
                                    this.isPrinterDetailsPanelVisible = true;
                                }
                                else {
                                    var markerPopupHeight = document.getElementById('infoObj').clientHeight || 329;
                                    map.panBy(0, -(markerPopupHeight / 2));
                                    if (this.isPrinterDetailsPanelVisible) {
                                        this.isPrinterDetailsPanelVisible = false;
                                        Vue.nextTick()
                                            .then(function () {
                                                infoWindow.open(map, this.currentPopup);
                                            });
                                    }
                                }
                            }
                        }
                    },
                    isSearchBarSelected: function (val) {
                        if (val) {
                            this.isPlacesListVisible = val;
                        }
                    },
                    isPlacesListVisible: function (val) {
                        if (val) {
                            Vue.nextTick()
                                .then(function () {
                                    scrollHeaders.init(document.getElementById('placesList'));
                                    this.fitMapToDisplay(val);
                                }.bind(this));
                        }
                    },
                    selectedPrinterId: function (val) {
                        this.isSelectedPrinterDataLoading = true;

                        axios.get('/api/v1.0/printers/' + val)
                            .then((response) => {
                                this.selectedPrinterData = response.data;
                                this.isSelectedPrinterDataLoading = false;
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                }
            });

            function isJSON(str) {
                try {
                    return (JSON.parse(str) && !!str);
                } catch (e) {
                    return false;
                }
            }
            let mapZoom = document.getElementById('map').dataset.zoom;
            let mapCenter = document.getElementById('map').dataset.center;
            mapCenter = isJSON(mapCenter) ? JSON.parse(mapCenter) : {};
            if (mapCenter.lat === undefined || mapCenter.lng === undefined) {
                mapCenter.lat = 60;
                mapCenter.lng = 22;
            }
            if (!mapZoom) {
                mapZoom = '6';
            }
            let controlPosition = google.maps.ControlPosition.RIGHT_BOTTOM;
            if (window.currentLanguageCode === 'ar') {
                controlPosition = google.maps.ControlPosition.LEFT_BOTTOM
            }
            const mapOptions = {
                zoom: 6,
                zoom: parseInt(mapZoom),
                maxZoom: 17,
                gestureHandling: 'greedy',
                center: new google.maps.LatLng(mapCenter.lat, mapCenter.lng),
                disableDefaultUI: true,
                //mapId: "DEMO_MAP_ID",
                zoomControl: true,
                zoomControlOptions: {
                    style: google.maps.ZoomControlStyle.SMALL,
                    position: controlPosition
                },
                styles: [
                    {
                        featureType: 'poi.business',
                        stylers: [{ visibility: 'off' }],
                    },
                    {
                        featureType: 'transit',
                        elementType: 'labels.icon',
                        stylers: [{ visibility: 'off' }],
                    },
                ],
            }
            let map = new google.maps.Map(document.getElementById('map'), mapOptions);
            infoWindow = new google.maps.InfoWindow({
                disableAutoPan: true,
            });
            google.maps.event.addListener(map, 'click', function (event) {
                infoWindow.close();
                this.mapApp.currentPopup = null;
                this.mapApp.isPlacesListVisible = false;
            }.bind(this));
        });
    }
}

export default MapNew;